import { render, staticRenderFns } from "./BranchOfficeCommon.vue?vue&type=template&id=4f055696"
import script from "./BranchOfficeCommon.vue?vue&type=script&lang=js"
export * from "./BranchOfficeCommon.vue?vue&type=script&lang=js"
import style0 from "./BranchOfficeCommon.vue?vue&type=style&index=0&id=4f055696&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports